import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Box, Link} from 'views/components';
import {Translate} from 'views/module';

const NavbarService = (props) => {
  const {
    myTasksCount,
    allTasksCount,
    title,
    options = [],
    currentPath,
  } = props;

  const isButtonSelected = (buttonLink) => {
    if (buttonLink === '/') {
      return currentPath === '/';
    }

    return currentPath === buttonLink || currentPath.startsWith(`${buttonLink}/`);
  };

  return (
    <Box
      sx={{
        py: 1,
        px: 2,
        borderRadius: '8px',
      }}
    >
      {
        Boolean(title) &&
          <Typography
            sx={{
              'display': 'block',
              'py': '6px',
              'filter': 'contrast(25%)',
              'fontWeight': 400,
              'fontSize': '12px',
              'color': 'navbar.text',
            }}
          >
            <Translate expression={title} />
          </Typography>
      }
      {
        options.map((button, index) => {
          return (
            <Link
              href={button.link}
              sx={{
                'display': 'block',
                'borderRadius': '6px',
                'backgroundColor': isButtonSelected(button.link) ? 'background.highlighted' : undefined,
                'textDecoration': 'none',
              }}
              key={index}
            >
              <Box
                sx={{
                  'display': 'flex',
                  'alignItems': 'center',
                  'justifyContent': 'space-between',
                  'color': 'navbar.text',
                  'py': '6px',
                  'px': '16px',
                  'fontSize': '14px',
                  '&:hover': {
                    'backgroundColor': 'background.highlighted',
                    'borderRadius': '6px',
                  },
                }}
              >
                <Box
                  sx={{
                    'display': 'flex',
                    'alignItems': 'center',
                    'gap': '12px',
                  }}
                >
                  {button.icon}
                  <Typography
                    sx={{
                      color: 'navbar.text',
                      fontSize: '14px',
                      fontWeight: isButtonSelected(button.link) ? 500 : 400,
                    }}
                  >
                    <Translate expression={button.title} />
                  </Typography>
                </Box>
                {
                  (
                    (button.count === 'mytasks' && myTasksCount > 0) ||
                    (button.count === 'alltasks' && allTasksCount > 0)
                  ) &&
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: isButtonSelected(button.link) ? '#FEF2F2' : 'background.highlighted',
                        fontSize: '12px',
                        width: '1.75rem',
                        borderRadius: 1,
                        border: isButtonSelected(button.link) ? '2px solid #FECACA' : '2px solid #e8e4de',
                        color: isButtonSelected(button.link) ? '#DC2626' :'#a8a49e',
                      }}
                    >
                      {
                        button.count === 'mytasks' && (
                          myTasksCount > 99 ? '+99': myTasksCount
                        )
                      }
                      {
                        button.count === 'alltasks' && (
                          allTasksCount > 99 ? '+99': allTasksCount
                        )
                      }
                    </Box>
                }
              </Box>
            </Link>
          );
        })
      }
    </Box>
  );
};
NavbarService.propTypes = {
  title: PropTypes.string,
  currentPath: PropTypes.string,
  options: PropTypes.array,
  myTasksCount: PropTypes.number,
  allTasksCount: PropTypes.number,
};
const mapStateToProps = (state) => ({
  myTasksCount: state.taskRefresh?.myTasksCount,
  allTasksCount: state.taskRefresh?.allTasksCount,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarService));
